import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import {FirmWareInfo, FirmwareInfoParam} from '../firm-ware.model';

export enum FirmWareInfoActionTypes {
  LoadFirmWares = '[FirmWareInfo] Load FirmWares',
  LoadFirmwareInfo = '[FirmWareInfo] Load FirmwareInfo',
  LoadFirmwareList = '[FirmWareInfo] Load FirmwareList',
  GetFirmWares = '[FirmWareInfo] Get FirmWares',
  GetFirmWaresFail = '[FirmWareInfo] Get FirmWares Fail',
  GetFirmwareInfo = '[FirmWareInfo] Get FirmwareInfo',
  GetFirmwareInfoFail = '[FirmWareInfo] Get FirmwareInfo Fail',
  GetFirmwareList = '[FirmWareInfo] Get FirmwareList',
  GetFirmwareListFail = '[FirmWareInfo] Get FirmwareList Fail',
  GetAddFirmwareInfo = '[FirmWareInfo] Get Add FirmwareInfo',
  GetUpdateFirmwareInfo = '[FirmWareInfo] Get Update FirmwareInfo',
  GetReleaseFirmwareInfo = '[FirmWareInfo] Get Release FirmwareInfo',
  AddFirmwareInfo = '[FirmWareInfo] Add FirmwareInfo',
  AddFirmwareInfoFail = '[FirmWareInfo] Add FirmwareInfo Fail',
  UpdateFirmwareInfo = '[FirmWareInfo] Update FirmwareInfo',
  UpdateFirmwareInfoFail = '[FirmWareInfo] Update FirmwareInfo Fail',
  ReleaseFirmwareInfo = '[FirmWareInfo] Release FirmwareInfo',
  ReleaseFirmwareInfoFail = '[FirmWareInfo] Release FirmwareInfo Fail'
}

export class LoadFirmWares implements Action {
  readonly type = FirmWareInfoActionTypes.LoadFirmWares;
  constructor(public payload: FirmWareInfo[]) {}
}

export class LoadFirmwareInfo implements Action {
  readonly type = FirmWareInfoActionTypes.LoadFirmwareInfo;
  constructor(public payload: FirmWareInfo) {}
}

export class LoadFirmwareList implements Action {
  readonly type = FirmWareInfoActionTypes.LoadFirmwareList;
  constructor(public payload: FirmWareInfo[]) {}
}

export class GetFirmWares implements Action {
  readonly type = FirmWareInfoActionTypes.GetFirmWares;
}

export class GetFirmWaresFail implements Action {
  readonly type = FirmWareInfoActionTypes.GetFirmWaresFail;
}

export class GetFirmwareInfo implements Action {
  readonly type = FirmWareInfoActionTypes.GetFirmwareInfo;
  constructor(public payload: number) {}
}

export class GetFirmwareInfoFail implements Action {
  readonly type = FirmWareInfoActionTypes.GetFirmwareInfoFail;
}

export class GetFirmwareList implements Action {
  readonly type = FirmWareInfoActionTypes.GetFirmwareList;
  constructor(public payload: { ids: number[], FWType: number }) {}
}

export class GetFirmwareListFail implements Action {
  readonly type = FirmWareInfoActionTypes.GetFirmwareListFail;
}

export class GetAddFirmwareInfo implements Action {
  readonly type = FirmWareInfoActionTypes.GetAddFirmwareInfo;
  constructor(public payload: {firmwareInfo: FirmwareInfoParam}) {}
}

export class AddFirmwareInfo implements Action {
  readonly type = FirmWareInfoActionTypes.AddFirmwareInfo;
  constructor(public payload: FirmWareInfo) {}
}

export class AddFirmwareInfoFail implements Action {
  readonly type = FirmWareInfoActionTypes.AddFirmwareInfoFail;
}

export class GetUpdateFirmwareInfo implements Action {
  readonly type = FirmWareInfoActionTypes.GetUpdateFirmwareInfo;
  constructor(public payload: {firmwareInfo: FirmwareInfoParam}) {}
}

export class UpdateFirmwareInfo implements Action {
  readonly type = FirmWareInfoActionTypes.UpdateFirmwareInfo;
  constructor(public payload: { module: Update<FirmWareInfo> }) {}
}

export class UpdateFirmwareInfoFail implements Action {
  readonly type = FirmWareInfoActionTypes.UpdateFirmwareInfoFail;
}

export class GetReleaseFirmwareInfo implements Action {
  readonly type = FirmWareInfoActionTypes.GetReleaseFirmwareInfo;
  constructor(public payload: {firmwareInfo: FirmwareInfoParam}) {}
}

export class ReleaseFirmwareInfo implements Action {
  readonly type = FirmWareInfoActionTypes.ReleaseFirmwareInfo;
  constructor(public payload: { module: Update<FirmWareInfo> }) {}
}

export class ReleaseFirmwareInfoFail implements Action {
  readonly type = FirmWareInfoActionTypes.ReleaseFirmwareInfoFail;
}

export type FirmWareInfoActions = LoadFirmWares
  | LoadFirmwareInfo
  | LoadFirmwareList
  | GetFirmWares
  | GetFirmWaresFail
  | GetFirmwareInfo
  | GetFirmwareInfoFail
  | GetFirmwareList
  | GetFirmwareListFail
  | GetAddFirmwareInfo
  | GetUpdateFirmwareInfo
  | GetReleaseFirmwareInfo
  | AddFirmwareInfo
  | AddFirmwareInfoFail
  | UpdateFirmwareInfo
  | UpdateFirmwareInfoFail
  | ReleaseFirmwareInfo
  | ReleaseFirmwareInfoFail;
